// import { MQTTService } from 

import axios from 'axios';
export * from '../../public/common/vue/api/leanbot_js_api'
export * from './gatt-command'
export * from './mqtt-service';


interface IReplayInfoItem{
    is_public:number;
    mission_id:number;
    mission_name:string;
    mission_run_id:number;
    username:string;
}
interface IReplayInfo{
    [key:string]:IReplayInfoItem[];
}

export class PromiseDefer<T> {
    promise: Promise<T>;
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason?: any) => void;
    constructor() {
        this.promise=new Promise<T>((resolve,reject)=>{
            this.resolve=resolve;
            this.reject=reject;
        })
    }
}
interface IRawParse {
    RobotId: string;
    RobotX: number;
    RobotY: number;
    RobotDegree: number;
    RobotStatus: string;
    RobotTime: number;
    RobotScore: number;
    RobotTB1A: number;
    RobotTB1B: number;
    RobotTB2A: number;
    RobotTB2B: number;
    
}
export interface IReplayPageContent {
    data?:IRawParse;
    content:string;
    count:number;
    created_at:string;
    duration:string;
    hash:string;
    is_public:number;
    mission_id:number;
    mission_run_id:string;
    mqtt_id:number;
    robot_time:number;
    score:number;
    start_date:string;
    status:number;
    updated_at:string;
    user_id:number;
}
interface IReplayPage{
    [page:string]:Promise<IReplayPageContent[]>;
}
interface IReplayList{
    [replayId:string]:IReplayPage;
}
var replayList:IReplayList={};

export async function getReplayPage(replayId:any,page:any): Promise<IReplayPageContent[]> {
    replayList[replayId]=replayList[replayId]||{};
    if (replayList[replayId] && replayList[replayId][page]) {

    } else {
        // var obj={};
        replayList[replayId][page]= axios.get(`/logs/replay/${replayId}/${page}`)
        .then(res => res.data.map((r:IReplayPageContent)=>{
            r.data=JSON.parse(r.content);
            r.data.RobotX=parseFloat(`${r.data.RobotX}`);
            r.data.RobotY=parseFloat(`${r.data.RobotY}`);
            r.data.RobotDegree=parseFloat(`${r.data.RobotDegree}`);
            r.data.RobotTime=parseFloat(`${r.data.RobotTime}`);
            r.data.RobotScore=parseInt(`${r.data.RobotScore}`);
            // obj=Object.assign(obj,r.data);
            // console.log(obj);
            return r;
        }))
        .catch(e => false);
    }
    return await replayList[replayId][page]
   
    
    
}

var replayInfo:IReplayInfo={}
export async function getReplayInfo(replayId:any): Promise<IReplayInfoItem[]> {
    
    if (!replayInfo[replayId]) {
        replayInfo[replayId]=await  axios.get(`/logs/replay-info/${replayId}`).then(res => res.data);
    }
    var rs= replayInfo[replayId];
    // debugger;
        // return await replayInfo[replayId];
    
    return rs;

}
